// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useRootOrganizationStore from '@/app/store/rootOrganization';
import actionsPushPayments from '../../api/actionsPushPayments';
import usePushPaymentStore from '@/app/store/modules/pushPayment';
// Components
import DataTable from '@/common-utils/components/renders/dataTable/DataTable';
// Common
import { columnsPartners, columnsPartnersId } from './columnsDef/columnsPartners';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';

/**
 * @param root0
 * @param root0.filtersEventName
 *@returns {JSX} PartnersTable
 */
function PartnersTable({ filtersEventName }) {
    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { queryPartners: queryStored, storeQueryPartners } = usePushPaymentStore();

    // Constants
    const initialQuery = getInitialQuery();

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, error, refetch } = actionsPushPayments.getPartners({ query }, false);
    useEffect(() => {
        if (rootOrganization && launchRefetch) {
            refetch();
            setLaunchRefetch(false);
        }
    }, [query, launchRefetch, rootOrganization]);

    const allColumns = columnsPartners({ query, setQuery, queryStored, storeQueryPartners, setLaunchRefetch, filtersEventName });

    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            error={error}
            refetch={refetch}
            columnsId={columnsPartnersId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQueryPartners}
            setLaunchRefetch={setLaunchRefetch}
        />
    );
}

PartnersTable.propTypes = {
    filtersEventName: PropTypes.string
};

export default PartnersTable;